import React from 'react';

const ApiContext = React.createContext({
  schema: undefined,
  router: undefined,
});

export default ApiContext;
